<template>
  <span>
    {{ descricao }}
  </span>
</template>

<script>

const MODOS_TRANSPORTE = {
  0: '0 - Por conta do remetente',
  1: '1 - Por conta do destinatário',
  2: '2 - Por conta de terceiros',
  3: '3 - Transporte próprio por conta do remetente',
  4: '4 - Transporte próprio por conta do destinatário',
  9: '9 - Sem ocorrência de transporte',
};

export default {
  props: {
    modoTransporte: {
      type: String,
      required: true,
    },
  },
  computed: {
    descricao() {
      return MODOS_TRANSPORTE[this.modoTransporte] || 'Desconhecido';
    },
  },
};
</script>
